import GUI from 'lil-gui'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import firefliesVertexShader from './shaders/fireflies/vertex.glsl'
import firefliesFragmentShader from './shaders/fireflies/fragment.glsl'
import portalVertexShader from './shaders/portal/vertex.glsl'
import portalFragmentShader from './shaders/portal/fragment.glsl'
import Debug from "./Experience/Utils/Debug.js";
import waterVertexShader from './shaders/water/vertex.glsl'
import waterFragmentShader from './shaders/water/vertex.glsl'




// console.log(portalVertexShader);
// console.log(portalFragmentShader);
/**
 * Base
 */
const debugObject = {};

// Debug
const gui = new GUI({
    width: 400
})

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()


/**
 * Water
 */

// Geometry
const waterGeo = new THREE.PlaneGeometry(2,2,128, 128);

// Material
const waterMat = new THREE.ShaderMaterial({
    vertexShader: portalVertexShader,
    fragmentShader: portalFragmentShader,
});

// Mesh
const water = new THREE.Mesh(waterGeo, waterMat);
water.rotation.x = - Math.PI * 0.5;
scene.add(water);




/**
 * Loaders
 */
// Texture loader
const textureLoader = new THREE.TextureLoader()

// Draco loader
const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath('draco/')

// GLTF loader
const gltfLoader = new GLTFLoader()

// region: Portal
/*

/!** Load Portal mesh
 *
 *!/

// Texture
const bakedTexture = textureLoader.load('portal/baked_mp.jpg');
bakedTexture.flipY = false;
bakedTexture.colorSpace = THREE.SRGBColorSpace;

// Materials
const bakedMaterial = new THREE.MeshBasicMaterial({ map: bakedTexture});

// Emission Pole light
const poleLightMaterial = new THREE.MeshBasicMaterial({ color: 0xffffe5 });

// Emission Portal Gloom
debugObject.portalColorStart = '#c388a4';
debugObject.portalColorEnd = '#180d08';

gui.addColor(debugObject, 'portalColorStart').onChange(() => {
    portalGloomMaterial.uniforms.uColorStart.value.set(debugObject.portalColorStart);
})

gui.addColor(debugObject, 'portalColorEnd').onChange(() => {
    portalGloomMaterial.uniforms.uColorEnd.value.set(debugObject.portalColorEnd);
})

const portalGloomMaterial = new THREE.ShaderMaterial({ 
    uniforms: {
        uTime: { value: 0 },
        uColorStart: {value: new THREE.Color(debugObject.portalColorStart)},
        uColorEnd: { value: new THREE.Color(debugObject.portalColorEnd)},
    },
    vertexShader: portalVertexShader,
    fragmentShader: portalFragmentShader,
});

// Model
gltfLoader.load(
    'portal/portal_mp.glb',
    (gltf) => {
        console.log(gltf.scene.children);

        const bakedMesh = gltf.scene.children.find(child => child.name === 'baked');
        bakedMesh.material = bakedMaterial;
        gltf.scene.traverse((child) => {

            if (child.name === 'LightPoleA' || child.name === 'LightPoleB') {
                child.material = poleLightMaterial;
            }

            if (child.name === 'PortalGloom') {
                child.material = portalGloomMaterial;
            }
        });

        scene.add(gltf.scene)
    }
)

/!**
 * Fireflies
 *!/
// Geometry
const firefliesGeometry = new THREE.BufferGeometry();
const firefliesCount = 30;
const positionArray = new Float32Array(firefliesCount * 3);
const scaleArray = new Float32Array(firefliesCount);

for (let i = 0; i < firefliesCount; i++) {
    positionArray[i * 3] = (Math.random() - 0.5) * 4;
    positionArray[i * 3 + 1] = (Math.random()) * 1.5;
    positionArray[i * 3 + 2] = (Math.random() - 0.5) * 4;
    
    scaleArray[i] = Math.random();
}

firefliesGeometry.setAttribute('position', new THREE.BufferAttribute(positionArray, 3));
firefliesGeometry.setAttribute('aScale', new THREE.BufferAttribute(scaleArray, 1));

// Material
const firefliesMaterial = new THREE.ShaderMaterial({
    uniforms: {
        uTime: {value: 0},
        uPixelRatio: { value: Math.min(window.devicePixelRatio, 2)},
        uSize: { value: 100 }
    },
    vertexShader: firefliesVertexShader,
    fragmentShader: firefliesFragmentShader,
    transparent: true,
    blending: THREE.AdditiveBlending,
    depthWrite: false,
});

gui.add(firefliesMaterial.uniforms.uSize, 'value').min(0).max(500).step(1).name('Fireflies Size');

// Points
const fireflies = new THREE.Points(firefliesGeometry, firefliesMaterial);

scene.add(fireflies);
*/
// endregion: Portal



/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    
    // Update fireflies Shader
    //firefliesMaterial.uniforms.uPixelRatio.value = Math.min(window.devicePixelRatio, 2);
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(45, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 4
camera.position.y = 2
camera.position.z = 4
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

debugObject.clearColor = '#451c00';
renderer.setClearColor(debugObject.clearColor);
gui.addColor(debugObject, 'clearColor').onChange(() => {
    renderer.setClearColor(debugObject.clearColor);
});

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    
    // Update shader time
    //firefliesMaterial.uniforms.uTime.value = elapsedTime;
    //portalGloomMaterial.uniforms.uTime.value = elapsedTime;

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()